
import {
  defineComponent, computed, reactive, toRefs, watch,
} from '@vue/composition-api';
import VisTileLarge from '@/components/vis/VisTileLarge.vue';
import LayoutGrid from '@/components/LayoutGrid.vue';
import store from '../../../store';
import ScorePlot from './ScorePlot.vue';
import ScreePlot from './ScreePlot.vue';
import LoadingsPlot from './LoadingsPlot.vue';

export default defineComponent({
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    ScorePlot,
    ScreePlot,
    LoadingsPlot,
    VisTileLarge,
    LayoutGrid,
  },
  setup(props) {
    const plot = reactive({
      pcXval: '1',
      pcYval: '2',
      numComponentsVal: '10',
      pcX: 1,
      pcY: 2,
      numComponents: 10,
      showEllipses: true,
      showCrosshairs: true,
      showCutoffs: true,
      showScree: true,
      showScore: true,
      showLoadings: true,
    });

    const ready = computed(() => {
      const pcaReady = store.getters.ready(props.id, 'pca');
      const loadingsReady = store.getters.ready(props.id, 'loadings');

      return pcaReady && loadingsReady;
    });

    watch(() => plot.pcXval, (newPcXval) => {
      const newPcX = Number.parseInt(newPcXval, 10);
      if (!Number.isNaN(newPcX)) {
        plot.pcX = newPcX;
      }
    });
    watch(() => plot.pcYval, (newPcYval) => {
      const newPcY = Number.parseInt(newPcYval, 10);
      if (!Number.isNaN(newPcY)) {
        plot.pcY = newPcY;
      }
    });
    watch(() => plot.numComponentsVal, (newNumComponentsVal) => {
      const newNumComponents = Number.parseInt(newNumComponentsVal, 10);
      if (!Number.isNaN(newNumComponents)) {
        plot.numComponents = newNumComponents;
      }
    });

    return {
      ...toRefs(plot),
      ready,
    };
  },
});
